import { Grid } from '@mui/material';
import { RoutalDialog, RoutalLoader, RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';
import { useNavigate } from 'react-router-dom';

import { millisecondsToMMss } from '@nx-smartmonkey/shared/helpers';
import { useEffect, useState } from 'react';
import RoutalLogoGreen from '../../../../assets/img/routal-star-green.svg';
import * as routing from '../../../../constants/Routing';
import { useRetrieveActivePlan } from '../../../../hooks/plan/useRetrieveActivePlan';
import { useRetrieveActivePlanOptimization } from '../../../../hooks/plan/useRetrieveActivePlanOptimization';
import { useInterval } from '../../../../hooks/useInterval';
import Text from '../../../../react-components/Text';

export const OptimizationDialog = () => {
  const navigate = useNavigate();
  const { data: activePlan } = useRetrieveActivePlan();
  const { data: optimization } = useRetrieveActivePlanOptimization();
  const [duration, setDuration] = useState<number | undefined>(undefined);

  useInterval({
    callback: () => {
      setDuration((duration) => duration! + 1000);
    },
    enabled: optimization?.status === `running` && duration !== undefined,
    delay: 1000,
  });

  useEffect(() => {
    if (optimization?.status === `running`) {
      setDuration(new Date().getTime() - new Date(optimization.startedAt!).getTime());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [optimization]);

  if (!activePlan || !optimization) {
    return null;
  }

  return (
    <RoutalDialog
      open={optimization.status === `running`}
      onCloseDialog={(e: any) => {
        e.preventDefault();
      }}
      dialogProps={{
        disableEscapeKeyDown: true,
        maxWidth: `xs`,
      }}
      showHeader={false}
      showFooter={false}
      showCrossCloseButton={false}
    >
      <Grid container direction="column" alignItems="center" justifyContent="center">
        <div style={{ position: `relative` }}>
          <RoutalLoader width={60} strokeWidth={1} />

          <img
            style={{ width: `34px`, top: `28px`, left: `30px`, position: `absolute` }}
            src={RoutalLogoGreen}
            alt=""
            draggable={false}
          />
        </div>

        <Text variant="h6" intlId="planner.plan_details.optimizing.title" style={{ color: RoutalPalette.primary40 }} />

        <VSpacer medium />

        <Text variant="h5" style={{ color: RoutalPalette.primary40 }}>
          {duration ? millisecondsToMMss(duration) : undefined}
        </Text>

        <VSpacer small />
        {activePlan.optimizer_config?.time_limit_seconds !== undefined ? (
          <>
            <Text
              variant="body-medium"
              intlId="planner.plan_details.optimizing.time_limit"
              intlValues={{
                time: millisecondsToMMss(activePlan.optimizer_config?.time_limit_seconds * 1000),
              }}
            />
            <VSpacer small />
          </>
        ) : null}

        <Grid container direction="row">
          <Text
            variant="button"
            onClick={() => {
              navigate(`${routing.PLANNER.PLANS.replace(`:projectId`, activePlan?.project_id ?? ``)}`);
            }}
            style={{ fontSize: `10px`, color: RoutalPalette.secondary00 }}
            intlId="planner.plan_details.optimizing.back"
          />
        </Grid>
      </Grid>
    </RoutalDialog>
  );
};
